// .directive('hpOverlay',

export default function LeadResultTextDirective() {
    return {
        restrict: 'E',
        scope: {
            lead: '=',
            nonPrequalText: '@'
        },
        link(scope, elem, attr) {
            if (!!scope.lead.leadData) {
                scope.PrequalResultDecisionTypeID = scope.lead.leadData.PrequalResultDecisionTypeID;
            } else {
                scope.PrequalResultDecisionTypeID = scope.lead.PrequalResultDecisionTypeID;
            }
        },
        template: `
        <div>
            <p class="result-summary" ng-if="lead.isFullPrequal && (PrequalResultDecisionTypeID == 1 || PrequalResultDecisionTypeID == 2)">Excellent news! It looks like this homeowner can qualify for HERO. We may only need income information in order to get this homeowner approved. </p>
            <p class="result-summary" ng-if="lead.isFullPrequal && (PrequalResultDecisionTypeID == 0 || PrequalResultDecisionTypeID == 3)"> Great news! It looks like this homeowner may qualify for HERO. We may need additional information about the homeowner and their home.</p>
            <p class="result-summary" ng-if="lead.isFullPrequal && (PrequalResultDecisionTypeID == 4 || PrequalResultDecisionTypeID == 5)">This homeowner is in a HERO approved area. We will need additional information about the homeowner and their home during the application process.</p>
            <p class="result-summary" ng-if="!lead.isFullPrequal"> {{nonPrequalText}} </p>
        </div>
        `,
    };
}


// WEBPACK FOOTER //
// ./src/app/lead/leadResultTextDirective.js